import { render, staticRenderFns } from "./SpinnerLoader.vue?vue&type=template&id=01e9b066"
import script from "./SpinnerLoader.vue?vue&type=script&lang=js"
export * from "./SpinnerLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01e9b066')) {
      api.createRecord('01e9b066', component.options)
    } else {
      api.reload('01e9b066', component.options)
    }
    module.hot.accept("./SpinnerLoader.vue?vue&type=template&id=01e9b066", function () {
      api.rerender('01e9b066', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/psd-layers/SpinnerLoader.vue"
export default component.exports